import { PIN } from '../types';

export const searchInitialState = {
  pin: true,
  pins: [],
};

const pinReducer = (state = searchInitialState, action) => {
  switch (action.type) {
    case PIN.PIN_TRIGGER:
      return {
        pin: !state.pin,
      };
    case PIN.SET_PINS:
      return {
        pins: action.value.map((x) => x.assignId),
      };
    default:
      return state;
  }
};

export default pinReducer;
